export const copyRight = '© Ellen MacArthur Foundation';

export const description =
  'The Ellen MacArthur Foundation works to accelerate the transition to a circular economy. We develop and promote the idea of a circular economy, and work with business, academia, policymakers, and institutions to mobilise systems solutions at scale, globally.';

export const registrationNumbers = [
  'Charity Registration No. (England and Wales): 1130306',
  'OSCR Registration No. (Scotland): SC043120',
  'Company No.: 6897785',
  'Ellen MacArthur Foundation ANBI RSIN (Netherlands): 8257 45 925',
];

export const primaryLinks = [
  {
    title: 'About us',
    url: `/about-us/what-we-do`,
  },
  {
    title: 'Our network',
    url: `/network/overview`,
  },
  {
    title: 'Careers',
    url: `/careers/overview`,
  },
  {
    title: 'Contact us',
    url: `/contact-us`,
  },
  {
    title: 'Regions',
    url: `/regions/overview`,
  },
  {
    title: 'Media centre',
    url: `/media-centre/overview`,
  },
];

export const secondaryLinks = [
  // Optional - currently all links fit in one column
];

export const subContentLinks = [
  {
    title: 'Policies',
    url: '/policies',
  },
  {
    title: 'Cookies',
    url: '/cookies',
  },
];

export const partners = {
  text: 'The work of the Ellen MacArthur Foundation is supported by our ',
  linkText: 'Strategic Partners and Partners.',
  linkUrl: '/network/who-is-in-the-network',
};

export const socialLinks = [
  {
    type: 'linkedIn',
    alt: 'Link to EMF LinkedIn page. Opens in a new tab.',
    url: 'https://uk.linkedin.com/company/ellen-macarthur-foundation',
  },
  {
    type: 'youTube',
    alt: 'Link to EMF YouTube page. Opens in a new tab.',
    url: 'https://www.youtube.com/user/made2bemadeagain',
  },
  {
    type: 'instagram',
    alt: 'Link to EMF Instagram page. Opens in a new tab.',
    url: 'https://www.instagram.com/ellenmacarthurfoundation/',
  },
  {
    type: 'medium',
    alt: 'Link to EMF Medium page. Opens in a new tab.',
    url: 'https://medium.com/@circulareconomy',
  },
];

export const poweredByContentful = {
  text: 'Powered by Contentful',
  url: 'https://www.contentful.com/',
};
